import { forwardRef } from 'react'
import { Button as MuiButton, CircularProgress } from '@mui/material'

const Button = forwardRef(({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  loading = false,
  disabled = false,
  startIcon,
  endIcon,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}, ref) => {
  return (
    <MuiButton
      ref={ref}
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : startIcon}
      endIcon={endIcon}
      fullWidth={fullWidth}
      onClick={onClick}
      type={type}
      className={className}
      {...props}
    >
      {children}
    </MuiButton>
  )
})

Button.displayName = 'Button'

export default Button
